import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { AppConfigService } from '@core/appconfig.service';
import { ZbPortalRedesignHelpers } from '@core/services/feature-flagged-features/zb-portal-redesign-helpers';
import { Observable, of } from 'rxjs';

@Component({
  selector: 'zbp-resources-header',
  templateUrl: './resources-header.component.html',
  styleUrls: ['./resources-header.component.scss'],
  imports: [
    CommonModule
  ]
})
export class ResourcesHeaderComponent {

  readonly isHighlights$: Observable<boolean>;
  readonly isRedesignView$: Observable<boolean>;

  constructor(
    private zbRedesignHelpers: ZbPortalRedesignHelpers,
    private appConfigService: AppConfigService,
  ) {
    this.isHighlights$ = of(appConfigService.isHighlightsPortalUrl);

    this.isRedesignView$ = of(
      this.zbRedesignHelpers.isZbPortal2024Active()
      || this.appConfigService.isHighlightsPortalUrl
    );
  }

}
